module.exports = __webpack_public_path__ + "img/Pic1.ffe93f74.svg";